<template>
  <div>
    <validation-observer ref="gapFormRef" tag="form">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-card-title>Información de la Obligación</b-card-title>

            <b-row>
              <b-col md="12">
                <b-form-group label="Obligación *" label-for="obligation">
                  <validation-provider name="Obligación" rules="required" v-slot="{ errors }">
                    <v-select
                      v-model="localFormData.obligation_id"
                      label="name"
                      :options="availableObligations"
                      :reduce="obligation => obligation._id"
                      placeholder="Seleccione una obligación"
                      @input="handleObligationSelect"
                      :disabled="isEdit"
                    >
                      <template #option="{ name, article, order }">
                        <strong>{{ order }}.</strong> {{ name }} <small class="text-muted">({{ article }})</small>
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="selectedObligation">
              <b-col md="2">
                <b-form-group label="N°" label-for="order">
                  <b-form-input v-model="selectedObligation.order" disabled />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Artículo" label-for="article">
                  <b-form-input v-model="selectedObligation.article" disabled />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Nombre" label-for="name">
                  <b-form-input v-model="selectedObligation.name" disabled />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="selectedObligation">
              <b-col md="12">
                <b-form-group label="Descripción" label-for="description">
                  <b-form-textarea
                    v-model="selectedObligation.description"
                    disabled
                    rows="3"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card>
            <b-card-title>Evaluación</b-card-title>

            <b-row>
              <b-col md="6">
                <b-form-group label="Estado *" label-for="status">
                  <validation-provider name="Estado" rules="required" v-slot="{ errors }">
                    <v-select
                      v-model="localFormData.status"
                      :options="statusOptions"
                      placeholder="Seleccione el estado"
                      @input="handleStatusChange"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group label="Evidencia" label-for="evidence">
                  <b-form-textarea
                    v-model="localFormData.evidence"
                    placeholder="Describa la evidencia de implementación (documentos, procesos, controles, etc.)"
                    rows="4"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="showGapSection">
        <b-col cols="12">
          <b-card>
            <b-card-title class="text-warning">
              <feather-icon icon="AlertTriangleIcon" class="mr-50" />
              Brecha Identificada
            </b-card-title>

            <b-row>
              <b-col md="12">
                <b-form-group label="Descripción de la Brecha *" label-for="gapDescription">
                  <validation-provider name="Descripción de la Brecha" :rules="showGapSection ? 'required' : ''" v-slot="{ errors }">
                    <b-form-textarea
                      v-model="localFormData.gapDescription"
                      placeholder="Describa específicamente qué no está implementado o qué está implementado parcialmente"
                      rows="4"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group label="Plan de Acción *" label-for="actionPlan">
                  <validation-provider name="Plan de Acción" :rules="showGapSection ? 'required' : ''" v-slot="{ errors }">
                    <b-form-textarea
                      v-model="localFormData.actionPlan"
                      placeholder="Describa las acciones específicas para remediar la brecha"
                      rows="4"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Responsable *" label-for="responsible">
                  <validation-provider name="Responsable" :rules="showGapSection ? 'required' : ''" v-slot="{ errors }">
                    <v-select
                      v-model="localFormData.responsible_id"
                      label="title"
                      :options="workersSupervised"
                      :reduce="worker => worker.value"
                      placeholder="Seleccione un responsable"
                    >
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Plazo *" label-for="deadline">
                  <validation-provider name="Plazo" :rules="showGapSection ? 'required' : ''" v-slot="{ errors }">
                    <b-form-datepicker
                      v-model="localFormData.deadline"
                      placeholder="Seleccione una fecha"
                      :min="new Date()"
                      locale="es"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Estado del Plan *" label-for="planStatus">
                  <validation-provider name="Estado del Plan" :rules="showGapSection ? 'required' : ''" v-slot="{ errors }">
                    <v-select
                      v-model="localFormData.planStatus"
                      :options="planStatusOptions"
                      placeholder="Seleccione el estado del plan"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="isEdit && localFormData.history && localFormData.history.length > 0">
        <b-col cols="12">
          <b-card>
            <b-card-title>Historial de Cambios</b-card-title>

            <b-table
              :items="localFormData.history"
              :fields="historyColumns"
              striped
              responsive
              small
            >
              <template #cell(timestamp)="data">
                {{ formatDateTime(data.item.timestamp) }}
              </template>

              <template #cell(action)="data">
                <b-badge :variant="getActionVariant(data.item.action)">
                  {{ data.item.action }}
                </b-badge>
              </template>

              <template #cell(changedFields)="data">
                <span v-if="data.item.changedFields">
                  {{ Object.keys(data.item.changedFields).join(', ') }}
                </span>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div class="d-flex justify-content-between">
            <b-button
              variant="outline-secondary"
              @click="handleCancel"
            >
              {{ $t('message.cancel') }}
            </b-button>

            <b-button
              variant="success"
              @click="handleSubmit"
            >
              {{ $t('message.submit') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </validation-observer>

    <!-- Audit Log Table -->
    <audit-log-table
      v-if="isEdit && formData"
      :history="formData.history || []"
      :field-translations="{
        obligation_id: $t('label.obligation'),
        status: $t('message.tableHeader.status'),
        evidence: $t('label.evidence'),
        gapDescription: $t('label.gapDescription'),
        actionPlan: $t('label.actionPlan'),
        responsible_id: $t('label.responsible'),
        deadline: $t('label.deadline'),
        planStatus: $t('label.planStatus')
      }"
    />
  </div>
</template>

<script>
import { BFormDatepicker, BBadge, BTable, BCardTitle } from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import AuditLogTable from '@/components/AuditLogTable.vue'
import { ref, computed, watch, onMounted } from '@vue/composition-api'
import { required } from '@validations'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import store from '@/store'
import useCommon from '@/views/organization/useCommon'

export default {
  name: 'GapForm',
  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
    AuditLogTable,
    BFormDatepicker,
    BBadge,
    BTable,
    BCardTitle,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { getItemsAggregate } = useLambda()
    const { getWorkersSupervisedForDropDown, workersSupervised } = useCommon()
    const { client } = store.state?.userStore?.userData

    const gapFormRef = ref(null)
    const localFormData = ref({ ...props.formData })
    const availableObligations = ref([])
    const selectedObligation = ref(null)

    const statusOptions = ['Implementado', 'Parcial', 'No implementado', 'No aplica']
    const planStatusOptions = ['Pendiente', 'En progreso', 'Cerrado']

    const historyColumns = [
      { key: 'timestamp', label: 'Fecha', sortable: true },
      { key: 'action', label: 'Acción', sortable: true },
      { key: 'changedFields', label: 'Campos Modificados' },
    ]

    const showGapSection = computed(() => {
      return localFormData.value.status === 'Parcial' || localFormData.value.status === 'No implementado'
    })

    const fetchObligations = async () => {
      try {
        const pipeline = [
          { $match: { deleted: { $ne: true } } },
          { $sort: { order: 1 } }
        ]

        const result = await getItemsAggregate({
          collection: 'gapObligation',
          pipeline
        })

        availableObligations.value = result || []

        if (props.isEdit && localFormData.value.obligation_id) {
          selectedObligation.value = availableObligations.value.find(
            o => o._id.$oid === localFormData.value.obligation_id.$oid
          )
        }
      } catch (error) {
        console.log(error)
      }
    }

    const handleObligationSelect = () => {
      selectedObligation.value = availableObligations.value.find(
        o => o._id === localFormData.value.obligation_id
      )
    }

    const handleStatusChange = () => {
      if (!showGapSection.value) {
        localFormData.value.gapDescription = ''
        localFormData.value.actionPlan = ''
        localFormData.value.responsible_id = null
        localFormData.value.deadline = null
        localFormData.value.planStatus = ''
      }
    }

    const formatDateTime = (timestamp) => {
      if (!timestamp) return '-'
      const d = new Date(timestamp)
      return d.toLocaleString('es-CL')
    }

    const getActionVariant = (action) => {
      const variants = {
        'created': 'success',
        'updated': 'info',
        'status_changed': 'warning',
      }
      return variants[action] || 'secondary'
    }

    const handleSubmit = async () => {
      const valid = await gapFormRef.value.validate()
      if (valid) {
        emit('submit', localFormData.value)
      }
    }

    const handleCancel = () => {
      emit('cancel')
    }

    watch(
      () => props.formData,
      (newVal) => {
        localFormData.value = { ...newVal }
      },
      { deep: true }
    )

    onMounted(() => {
      fetchObligations()
      getWorkersSupervisedForDropDown()
    })

    return {
      gapFormRef,
      localFormData,
      availableObligations,
      workersSupervised,
      selectedObligation,
      statusOptions,
      planStatusOptions,
      historyColumns,
      showGapSection,
      handleObligationSelect,
      handleStatusChange,
      handleSubmit,
      handleCancel,
      formatDateTime,
      getActionVariant,
      required,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
